import { registerBlockType } from '@wordpress/blocks'
import { Path, Rect, SVG } from '@wordpress/components'
import { InnerBlocks } from '@wordpress/block-editor'

registerBlockType('usna1978/classmate-professional-writings', {
  title: 'Classmate: Professional Writing',
  description: 'Add a section for external professional writings to be added to.',
  // eslint-disable-next-line react/jsx-pascal-case
  icon: <SVG viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><Path d='M0,0h24v24H0V0z' fill='none' /><Path d='M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M20,18H4V6h16V18z' /><Rect x='6' y='10' width='2' height='2' /><Rect x='6' y='14' width='8' height='2' /><Rect x='16' y='14' width='2' height='2' /><Rect x='10' y='10' width='8' height='2' /></SVG>,
  category: 'formatting',

  /**
   * The edit function describes the structure of your block in the context of
   * the editor. This represents what the editor will render when the block is
   * used.
   *
   * The "edit" property must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  edit () {
    return (
      <div className='panel panel-default'>
        <div className='panel-heading'>
          <strong>Professional Writings & Videos</strong>
        </div>
        <div className='panel-body'>
          <InnerBlocks />
        </div>
      </div>
    )
  },

  /**
   * The save function defines the way in which the different attributes should
   * be combined into the final markup, which is then serialized by Gutenberg
   * into post_content.
   *
   * The "save" property must be specified and must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  save () {
    return (
      <div className='panel panel-default'>
        <div className='panel-heading'>
          <strong>Professional Writings & Videos</strong>
        </div>
        <div className='panel-body'>
          <InnerBlocks.Content />
        </div>
      </div>
    )
  }
})
